// import { useQuery, useQueryClient } from "@tanstack/react-query";

export const SESSION_TOKEN_KEY = "baback-session-token";

// export function useSessionToken() {
//   return useQuery({
//     queryKey: ["session-token"],
//     queryFn: async () => {
//       return localStorage.getItem(SESSION_TOKEN_KEY);
//     },
//   });
// }

// export function useRefreshSessionToken() {
//   const client = useQueryClient();
//   return (data: { token: string | undefined }) => {
//     if (data.token) {
//       localStorage.setItem(SESSION_TOKEN_KEY, data.token);
//       client.setQueryData(["session-token"], data.token);
//     }
//   };
// }
